import { createContext } from "react";

/* Context */
export interface TabsContextType {
  activeTab: string | number;
  setActiveTab: (tab: string | number) => void;
  showActiveBg?: boolean;
}

export const TabsContext = createContext<TabsContextType | undefined>(undefined);
